function SectionFaqGeneral() {
    return (
        <>
            <div className="tw-faq-section">
                <div className="accordion tw-faq" id="sf-faq-accordion">
                    {/*One*/}
                    <div className="accordion-item">
                        <button className="accordion-button" type="button" data-bs-toggle="collapse" aria-expanded="true" data-bs-target="#FAQ1">
                            What is UniConsultX and how can it help my business?
                        </button>
                        <div id="FAQ1" className="accordion-collapse collapse show" data-bs-parent="#sf-faq-accordion">
                            <div className="accordion-body">
                                UniConsultX is an all-in-one business consulting firm offering legal, financial, digital, and licensing services. We help you start, structure, and scale your business—right from choosing the right brand name to getting it legally protected, financially compliant, digitally visible, and properly licensed.
                            </div>
                        </div>
                    </div>
                    {/*Two*/}
                    <div className="accordion-item">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#FAQ2" aria-expanded="false">
                            Why do I need a professional website for my business?
                        </button>
                        <div id="FAQ2" className="accordion-collapse collapse" data-bs-parent="#sf-faq-accordion">
                            <div className="accordion-body">
                                A professional website acts as your 24/7 digital storefront. It builds credibility, showcases your services, reaches a wider audience, and generates leads. In today's digital age, it's often the first point of contact a customer has with your brand.
                            </div>
                        </div>
                    </div>
                    {/*Three*/}
                    <div className="accordion-item">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#FAQ3" aria-expanded="false">
                            Why is good graphic design important for my brand?
                        </button>
                        <div id="FAQ3" className="accordion-collapse collapse" data-bs-parent="#sf-faq-accordion">
                            <div className="accordion-body">
                                Good graphic design makes your business look professional and trustworthy. It helps create a strong brand identity (your logo, colors, etc.), makes marketing materials more effective, and helps you stand out from the competition. Consistent, high-quality design builds brand recognition.
                            </div>
                        </div>
                    </div>
                    {/*Four*/}
                    <div className="accordion-item">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#FAQ4" aria-expanded="false">
                            What kind of businesses do you work with?
                        </button>
                        <div id="FAQ4" className="accordion-collapse collapse" data-bs-parent="#sf-faq-accordion">
                            <div className="accordion-body">
                                We work with a wide range of clients, from startups and small local businesses to large corporations and non-profits. Our design solutions are tailored to meet the unique needs and budget of each client.
                            </div>
                        </div>
                    </div>
                    {/*Five*/}
                    <div className="accordion-item">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#FAQ5" aria-expanded="false">
                            Do I need to be located in Indore to work with you?
                        </button>
                        <div id="FAQ5" className="accordion-collapse collapse" data-bs-parent="#sf-faq-accordion">
                            <div className="accordion-body">
                                Not at all! We serve clients across India and globally. We use email, phone calls, and video conferencing to communicate effectively, ensuring a smooth process regardless of your location.
                            </div>
                        </div>
                    </div>
                    {/*Six*/}
                    <div className="accordion-item">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#FAQ6" aria-expanded="false">
                            What is your design process from start to finish?
                        </button>
                        <div id="FAQ6" className="accordion-collapse collapse" data-bs-parent="#sf-faq-accordion">
                            <div className="accordion-body">
                                Our process is collaborative and structured: <br />
                                1.  Discovery & Consultation: We start by understanding your business, goals, and target audience. <br />
                                2.  Proposal & Quote: We provide a detailed project proposal outlining the scope, timeline, and cost. <br />
                                3.  Design Mockups: We create visual mockups of your website or graphic design for your review and feedback. <br />
                                4.  Development & Build (for websites): Once the design is approved, we build the functional website. <br />
                                5.  Review & Revisions: You get to review the work and request revisions. <br />
                                6.  Launch & Delivery: We launch your website or deliver the final design files. <br />
                            </div>
                        </div>
                    </div>
                    {/*Seven*/}
                    <div className="accordion-item">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#FAQ7" aria-expanded="false">
                            What do you need from me to get started?
                        </button>
                        <div id="FAQ7" className="accordion-collapse collapse" data-bs-parent="#sf-faq-accordion">
                            <div className="accordion-body">
                                To start, we typically need your company logo (if you have one), any brand guidelines, and the text (copy) and images you want to include. If you don't have these, don't worry! We can help with content creation and stock photography as part of the project.
                            </div>
                        </div>
                    </div>
                    {/*Eight*/}
                    <div className="accordion-item">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#FAQ8" aria-expanded="false">
                            How involved can I be in the process?
                        </button>
                        <div id="FAQ8" className="accordion-collapse collapse" data-bs-parent="#sf-faq-accordion">
                            <div className="accordion-body">
                                As involved as you'd like to be! We value your input and feedback at every stage. We see our clients as partners in the creative process.
                            </div>
                        </div>
                    </div>
                    {/*Nine*/}
                    <div className="accordion-item">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#FAQ9" aria-expanded="false">
                            Will my website be mobile-friendly?
                        </button>
                        <div id="FAQ9" className="accordion-collapse collapse" data-bs-parent="#sf-faq-accordion">
                            <div className="accordion-body">
                                Absolutely. All websites we build use responsive design, meaning they will automatically adapt to look great and function perfectly on all devices, including desktops, tablets, and smartphones.
                            </div>
                        </div>
                    </div>
                    {/*ten*/}
                    <div className="accordion-item">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#FAQ10" aria-expanded="false">
                            Will I be able to update the website myself?
                        </button>
                        <div id="FAQ10" className="accordion-collapse collapse" data-bs-parent="#sf-faq-accordion">
                            <div className="accordion-body">
                                Yes. We typically build websites on Content Management Systems (CMS) like WordPress. This allows you to easily update text, images, blog posts, and other content without any technical knowledge. We also provide basic training to help you get started.
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </>
    )
}

export default SectionFaqGeneral;
